import { IAsyncAction, IAction } from '@state/types';

export enum UserStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

/* Data models */
export interface UserData {
  email: string;
  name: string;
}

export interface IUserAccessBrand
{
  id:string
  name:string
}

export interface IUserAccess {
  id: string;
  user: UserData;
  status: UserStatus;
  createdDate?: Date;
  updateDate?: Date;
  brands?: IUserAccessBrand[]  
  createdBy: UserData,
  updatedBy: UserData,
  lastActive?: Date;
  hasAllAccess?: boolean
  industriesAllAccess?: string[]
  clientIds?: string[]
}


/* Reducer types */
export interface IUserAccessState {
  userAccesses?: IUserAccess[];
  response?: {};
  putSuccess?: IUserAccess;
  deletedUserAccess?:boolean
  searches?: IUserAccess[];
  counter?: {};
}

/* Actions types */

export interface IFetchUserAccessAction extends IAsyncAction {
  query?: string;
}

export interface IFetchSearchAction extends IAsyncAction {
  query?: string;
}

export interface IGetUserAccessByEmailAction extends IAsyncAction {
  email: string;
}


export interface IPostUserAccessAction extends IAsyncAction {
  userAccess: IUserAccess;
}

export interface IPutUserAccessAction extends IAsyncAction {
  userAccess: IUserAccess;
}

export interface IUpdateUserConfigAction extends IAsyncAction {
  userAccess: IUserAccess;
}

export interface IGetUserAccessAction extends IAsyncAction {
  email: string;
}

export interface IServerErrorAction extends IAction {
  error: any;
}

export interface IServerSuccessAction extends IAction {
  response: IUserAccess;
}

export interface ISetUserAccessAction extends IAction {
  userAccess: IUserAccess;
}

export interface ISetUserAccessesAction extends IAction {
  userAccesses: IUserAccess[];
}


export interface IDeleteUserAccessAction extends IAsyncAction {
  item: IUserAccess;  
}

export interface IDeleteUserAccessSuccess extends IAction {
}

export interface ISetSearchAction extends IAction {
  searches: IUserAccess[];
}

export interface ISetCounterAction extends IAction {
  counter: {};
}